import React from "react";

// Time grain only. `C` and `R` were never grains — they swapped the chart
// component entirely — so they are groups in the catalogue rail now.
const GRAIN_MODES = [
  { id: "A", label: "All time" },
  { id: "D", label: "Daily" },
  { id: "W", label: "Weekly" },
  { id: "M", label: "Monthly" },
  { id: "Y", label: "Yearly" },
];

/**
 * The footer control strip. Everything that steers the chart sits here, in one
 * strip under it, so the page's own nav stays the only header.
 *
 * Regression and Combination graphs respond to neither grain nor window, so
 * both groups render visibly disabled rather than live and inert.
 */
function AggregationControls({
  viewMode,
  setViewMode,
  viewOffset,
  setViewOffset,
  rangeLabel,
  disabled = false,
}) {
  const groupClass = `control-group${disabled ? " is-disabled" : ""}`;
  // NavButtons used to return null in All-time mode; the window simply has
  // nowhere to step there, so the stepper disables instead of vanishing.
  const windowDisabled = disabled || viewMode === "A";

  return (
    <div className="control-strip">
      <div className={groupClass}>
        <div className="grain-segmented">
          {GRAIN_MODES.map((mode) => (
            <button
              key={mode.id}
              type="button"
              className={viewMode === mode.id ? "active" : ""}
              onClick={() => setViewMode(mode.id)}
              disabled={disabled}
              aria-pressed={viewMode === mode.id}
            >
              {mode.label}
            </button>
          ))}
        </div>
      </div>

      <div className={groupClass}>
        <div className="window-stepper">
          <button
            type="button"
            onClick={() => setViewOffset((prev) => prev + 1)}
            disabled={windowDisabled}
            aria-label="Earlier window"
          >
            ◀
          </button>
          <span className="window-stepper__range">{rangeLabel}</span>
          <button
            type="button"
            onClick={() => setViewOffset((prev) => Math.max(0, prev - 1))}
            disabled={windowDisabled || viewOffset === 0}
            aria-label="Later window"
          >
            ▶
          </button>
        </div>
      </div>
    </div>
  );
}

export default AggregationControls;
